import ICoordinates from '../retailer/interfaces/coordinates.d';
import IRetailerAddress from '../retailer/interfaces/retailer-address.d';
import IAvailabilityData from './interfaces/availability-data.d';
import IRetailerVehicleAvailability from './interfaces/retailer-vehicle-availability.d';

class RetailerVehicleAvailability implements IRetailerVehicleAvailability {
  public testDriveVehicleId: number;

  public retailerId: number;

  public retailerName: string;

  public address: IRetailerAddress;

  public location: ICoordinates;

  public distanceInMiles: number;

  public availability: IAvailabilityData[];

  constructor(
    testDriveVehicleId: number,
    retailerId: number,
    retailerName: string,
    address: IRetailerAddress,
    location: ICoordinates,
    distanceInMiles: number,
    availability: IAvailabilityData[]
  ) {
    this.testDriveVehicleId = testDriveVehicleId;
    this.retailerId = retailerId;
    this.retailerName = retailerName;
    this.address = address;
    this.location = location;
    this.distanceInMiles = distanceInMiles;
    this.availability = availability;
  }
}

export default RetailerVehicleAvailability;
